import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { Vehicle } from '@commons/models/domain/Vehicle';
import { calculateVehicleTimeInCurrentState } from '@src/app/utils/vehicle-fncs';

@Component({
  selector: 'app-calculate-time',
  templateUrl: './calculate-time.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  styles: [`
    span {
      font-size: 11px;
      color: #000000;
      font-weight: normal;
    }
  `]
})
export class CalculateTimeComponent {

  @Input('data') set data(value: Vehicle) {
    this.calculate(value);
  }

  public value: number;

  constructor() { }

  private calculate(data: Vehicle): void {    
    this.value = calculateVehicleTimeInCurrentState(data);
  }

}
